function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}
var dispatchCustomEvent = function dispatchCustomEvent(eventName) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var detail = {
    detail: data
  };
  var event = new CustomEvent(eventName, data ? detail : null);
  document.dispatchEvent(event);
};
window.recentlyViewedIds = [];

if (!customElements.get('quantity-selector')) {
  class QuantityInput extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.input = this.querySelector('.qty');
      this.step = parseFloat(this.input.getAttribute('step')) || 1;
      this.changeEvent = new Event('change', { bubbles: true });

      // Create buttons
      this.subtract = this.querySelector('.minus');
      this.add = this.querySelector('.plus');

      // Add functionality to buttons
        if (this.subtract) {
          this.subtract.addEventListener('click', () => this.changeQuantity(-1 * this.step));
        }

        if (this.add) {
          this.add.addEventListener('click', () => this.changeQuantity(1 * this.step));
        }


      this.classList.add('buttons_added');
      this.validateQtyRules();
    }
    changeQuantity(change) {
      let quantity = parseInt(this.input.value) || 0;

      // Update quantity
      const newValue = Math.max(quantity + change, 1);

      // Check min and max values
      const min = parseInt(this.input.min) || 1;
      const max = parseInt(this.input.max) || Infinity;
      if (newValue < min || newValue > max) return;

      // Update input value
      this.input.value = newValue;

      // Dispatch change event
      this.input.dispatchEvent(this.changeEvent);

      // Update button states
      this.validateQtyRules();

      setTimeout(function() {
        cartDrawerUpdate();
      }, 1000);
      
    }

    validateQtyRules() {
      const value = parseInt(this.input.value) || 0;
      const min = parseInt(this.input.min) || 1;
      const max = parseInt(this.input.max) || Infinity;

      if (this.subtract) {
        this.subtract.classList.toggle('disabled', value <= min);
      }

      if (this.add) {
        this.add.classList.toggle('disabled', value >= max);
      }
    }

  }

  customElements.define('quantity-selector', QuantityInput);
  
}

function cartDrawerUpdate() {
  console.log("Calling cartDrawerUpdate");
  var url = window.location.href;
  fetch(url)
    .then(response => response.text())
    .then(html => {
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, 'text/html');
      console.log(doc);
      if (doc.querySelector('.js-ref') != null) {
       var mainSectionContent = doc.querySelector('.js-ref').innerHTML;
       document.querySelector('.js-ref').innerHTML = mainSectionContent;
      }
      if (doc.querySelector('.thb-cart-form--collaterals-inner') != null) {
       var mainSectionContent = doc.querySelector('.thb-cart-form--collaterals-inner').innerHTML;
       document.querySelector('.thb-cart-form--collaterals-inner').innerHTML = mainSectionContent;
      }
      if (doc.querySelector('.thb-cart-form--proceed') != null) {
       var mainSectionContent = doc.querySelector('.thb-cart-form--proceed').innerHTML;
       document.querySelector('.thb-cart-form--proceed').innerHTML = mainSectionContent;
      }
      setTimeout(function() {
          document.querySelectorAll('.product-subtotal').forEach(element => {
              if (element != null) {
                  element.innerHTML = element.innerHTML;
              }
          });
      }, 2000);
    })
    .catch(error => {
      console.error('Error fetching collection main section:', error);
    });
}

/**
 *  @class
 *  @function ProductCard
 */
if (!customElements.get('product-card')) {
  class ProductCard extends HTMLElement {
    constructor() {
      super();
      this.swatches = this.querySelector('.product-card-swatches');
      this.image = this.querySelector('.product-card-image-link .product-primary-image');
      this.additional_images = this.querySelectorAll('.product-secondary-image');
      this.additional_images_nav = this.querySelectorAll('.product-secondary-images-nav li');
      this.quick_add = this.querySelector('.product-card--add-to-cart-button-simple');
    }
    connectedCallback() {
      if (this.swatches) {
        this.enableSwatches();
      }
      if (this.additional_images) {
        this.enableAdditionalImages();
      }
      if (this.quick_add) {
        this.enableQuickAdd();
      }
    }
    enableAdditionalImages() {
      if (this._additionalImagesEnabled) return;
      this._additionalImagesEnabled = true;
      let image_length = this.additional_images.length;
      let images = this.additional_images;
      let nav = this.additional_images_nav;
      let image_container = this.querySelector('.product-card-image');

      let containerWidth = 0;
      let currentIndex = -1;

      if (image_container) {
        const ro = new ResizeObserver(entries => {
          containerWidth = entries[0].contentRect.width;
        });
        ro.observe(image_container);
      }

      const mousemove = function (e) {
        if (!containerWidth) containerWidth = this.getBoundingClientRect().width;
        let sel = Math.min(Math.floor((e.offsetX / containerWidth) * image_length), image_length - 1);
        if (sel === currentIndex) return;

        if (currentIndex >= 0 && images[currentIndex]) {
          images[currentIndex].classList.remove('hover');
          if (nav.length) nav[currentIndex].classList.remove('active');
        }
        currentIndex = sel;
        if (images[sel]) {
          images[sel].classList.add('hover');
          if (nav.length) nav[sel].classList.add('active');
        }
      };
      const mouseleave = function (e) {
        if (currentIndex >= 0 && images[currentIndex]) {
          images[currentIndex].classList.remove('hover');
          if (nav.length) nav[currentIndex].classList.remove('active');
        }
        currentIndex = -1;
      };
      if (image_container) {
        image_container.addEventListener('touchstart', mousemove, {
          passive: true
        });
        image_container.addEventListener('touchmove', mousemove, {
          passive: true
        });
        image_container.addEventListener('touchend', mouseleave, {
          passive: true
        });
        image_container.addEventListener('mouseenter', mousemove, {
          passive: true
        });
        image_container.addEventListener('mousemove', mousemove, {
          passive: true
        });
        image_container.addEventListener('mouseleave', mouseleave, {
          passive: true
        });
      }

      window.addEventListener('load', () => {
        images.forEach(function (image) {
          lazySizes.loader.unveil(image);
        });
      });

    }
    enableSwatches() {
      let swatch_list = this.swatches.querySelectorAll('.product-card-swatch');
      this.color_index = this.swatches.dataset.index;
      this.org_srcset = this.image ? this.image.dataset.srcset : '';

      this.addEventListener('change', this.onSwatchChange.bind(this));

      swatch_list.forEach((swatch) => {
        window.addEventListener('load', () => {
          let image = new Image();
          image.srcset = swatch.dataset.srcset;
          lazySizes.loader.unveil(image);
        });
        swatch.addEventListener('click', this.onSwatchClick);
        swatch.addEventListener('mouseover', this.onSwatchHover);
      });
    }
    onSwatchClick() {
      window.location.href = this.dataset.href;
    }
    onSwatchHover() {
      let swatch_input = this.previousElementSibling;
      swatch_input.checked = true;
      swatch_input.dispatchEvent(new Event('change', { bubbles: true }));
    }
    onSwatchChange(evt) {
      if (this.image) {
        if (evt.target.dataset.srcset) {
          this.image.setAttribute('srcset', evt.target.dataset.srcset);
        } else {
          this.image.setAttribute('srcset', this.org_srcset);
        }
      }
    }
   enableQuickAdd() {
      // Prevent duplicate listener bindings if element reconnects or init runs twice
      if (this.quick_add && !this.quick_add.dataset.bound) {
        // Keep a reference to the bound handler to avoid creating multiple closures
        this._onQuickAddClick = this._onQuickAddClick || this.quickAdd.bind(this);
        this.quick_add.addEventListener('click', this._onQuickAddClick);
        this.quick_add.dataset.bound = 'true';
      }
    }
    quickAdd(evt) {
      evt.preventDefault();
      if (this.quick_add.disabled || this.isAdding) {
        return;
      }
      // Guard against rapid clicks / duplicate listeners
      this.isAdding = true;
      this.quick_add.disabled = true;
      this.quick_add.classList.add('loading');
      this.quick_add.setAttribute('aria-disabled', true);

      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript'
        }
      };

      let formData = new FormData();

      formData.append('id', this.quick_add.dataset.productId);
      formData.append('quantity', 1);
      formData.append('sections', this.getSectionsToRender().map((section) => section.section));
      formData.append('sections_url', window.location.pathname);

      config.body = formData;

      fetch(`${theme.routes.cart_add_url}`, config)
        .then((response) => response.json())
                .then((data) => {
          console.log("Added to cart:", data);
          cartDrawerUpdateNew();
          if (data.sections) updateCartSections(data);
          setTimeout(cartOpen, 100);
          productRecommended();
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.quick_add.classList.remove('loading');
          this.quick_add.removeAttribute('aria-disabled');
          this.quick_add.disabled = false;
          this.isAdding = false;
        });

      return false;
    }
    getSectionsToRender() {
      return [{
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form--form'
      },
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      }
      // {
      //   id: 'cart-drawer-toggle',
      //   section: 'cart-bubble',
      //   selector: '.thb-secondary-area--item-count'
      // },
      // {
      //   id: 'cart-drawer-toggle',
      //   section: 'cart-bubble',
      //   selector: '.thb-secondary-area--item-amount'
      // }
    ];
    }
    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section => {
        if (!document.getElementById(section.id)) {
          return;
        }
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        
      }));



      if (document.getElementById('Cart-Drawer')) {
        document.getElementById('Cart-Drawer').open();
        document.getElementById('Cart-Drawer').removeProductEvent();
      }
      // initAccordion();
    }
    getSectionInnerHTML(html, selector = '.shopify-section') {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      const cartDrawer = doc.querySelector('.thb-cart-form--proceed');
      if (cartDrawer) {
        const mainSectionContent = cartDrawer.innerHTML;
        const currentCartDrawer = document.querySelector('.thb-cart-form--proceed');
        if (currentCartDrawer) {
          currentCartDrawer.innerHTML = mainSectionContent;
        }
      }

      return doc.querySelector(selector)?.innerHTML;
    }
  }
  customElements.define('product-card', ProductCard);
}

/**
 *  @class
 *  @function PanelClose
 */
if (!customElements.get('side-panel-close')) {
  class PanelClose extends HTMLElement {

    constructor() {
      super();
      let cc = document.querySelector('.click-capture');

      // Add functionality to buttons
      this.addEventListener('click', (e) => this.close_panel(e));
      document.addEventListener('panel:close', (e) => {
        let panel = document.querySelectorAll('.side-panel.active');
        if (panel.length) {
          this.close_panel(e, panel[0]);
        }
      });
      cc.addEventListener('click', (e) => {
        let panel = document.querySelectorAll('.side-panel.active');
        if (panel) {
          this.close_panel(e, panel[0]);
        }
      });
    }

    close_panel(e, panel) {
      if (e) {
        e.preventDefault();
      }
      if (!panel) {
        panel = e?.target.closest('.side-panel');

        if (!panel) {
          return;
        }
      }
      panel.classList.remove('active');
      document.body.classList.remove('open-cc', 'filter-open', 'sort-open');
      panel.setAttribute('inert', '');
    }
  }
  customElements.define('side-panel-close', PanelClose);

  document.addEventListener('keyup', (e) => {
    if (e.code) {
      if (e.code.toUpperCase() === 'ESCAPE') {
        dispatchCustomEvent('panel:close');
      }
    }
  });
}
/**
 *  @class
 *  @function CartDrawer
 */
if (!customElements.get('cart-drawer')) {
  class CartDrawer extends HTMLElement {

    constructor() {
      super();
    }

    connectedCallback() {
      this.isOpen = false;
      this.button = document.getElementById('cart-drawer-toggle');

      this.debouncedOnChange = debounce((event) => {
        this.onChange(event);
      }, 300);

      document.addEventListener('cart:refresh', (event) => {
        this.refresh();
      });

      this.addEventListener('change', this.debouncedOnChange.bind(this));

      this.removeProductEvent();

      document.addEventListener('click', this.onWindowClick.bind(this));

      // Add functionality to button
      this.button.addEventListener('click', (e) => {
        e.preventDefault();
        this.isOpen ? this.close() : this.open();
      });

      document.addEventListener('keyup', (e) => {
        if (e.code) {
          if (e.code.toUpperCase() === 'ESCAPE') {
            this.close();
          }
        }
      });
    }

    onWindowClick(event) {
      // if (!this.contains(event.target) && this.isOpen && !this.button.contains(event.target)) {
      //   this.close();
      // }
      const overlay = document.querySelector('.cart-overlay');
      const drawerTop = document.querySelector('.cart-drawer-top');
      const closeBtn = document.querySelector('.close-cart');

      if (
        (overlay && overlay.contains(event.target)) ||
        (drawerTop && drawerTop.contains(event.target)) ||
        (closeBtn && closeBtn.contains(event.target))
      ) {
        this.close();
      }
    }
    open() {
      this.removeAttribute('inert');
      this.focus();
      this.isOpen = true;
      dispatchCustomEvent('cart-drawer:open');
      document.body.classList.add("open-cart");
    }
    close() {
      this.setAttribute('inert', '');
      this.isOpen = false;
      document.body.classList.remove("open-cart");
    }
    onChange(event) {
      if (event.target.classList.contains('qty')) {
        this.updateQuantity(event.target.dataset.index, event.target.value);
      }
    }
    removeProductEvent() {

      let removes = this.querySelectorAll('.remove');

      removes.forEach((remove) => {
        remove.addEventListener('click', (event) => {
          this.updateQuantity(event.target.dataset.index, '0');
        });
      });
    }
    getSectionsToRender() {
      return [{
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer--inner'
      }
      // {
      //   id: 'cart-drawer-toggle',
      //   section: 'cart-bubble',
      //   selector: '.thb-secondary-area--item-count'
      // },
      // {
      //   id: 'cart-drawer-toggle',
      //   section: 'cart-bubble',
      //   selector: '.thb-secondary-area--item-amount'
      // }
    ];
    }
    getSectionInnerHTML(html, selector) {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector)?.innerHTML;
      
    }
    updateQuantity(line, quantity) {
      this.querySelector(`#CartDrawerItem-${line}`)?.classList.add('thb-loading');
      const body = JSON.stringify({
        line,
        quantity,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname
      });

      dispatchCustomEvent('line-item:change:start', {
        quantity: quantity
      });

      fetch(`${theme.routes.cart_change_url}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': `application/json`
        },
        ...{
          body
        }
      })
        .then((response) => {
          return response.text();
        })
        .then((state) => {
          const parsedState = JSON.parse(state);

          this.getSectionsToRender().forEach((section => {
            const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

            if (parsedState.sections) {
              elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
            }
          }));

          this.removeProductEvent();
          dispatchCustomEvent('line-item:change:end', {
            quantity: quantity,
            cart: parsedState
          });

          if (this.querySelector(`#CartDrawerItem-${line}`)) {
            this.querySelector(`#CartDrawerItem-${line}`).classList.remove('thb-loading');
          }
          productRecommended();
        });

        setTimeout(function() {
          var url = window.location.href;
            fetch(url)
              .then(response => response.text())
              .then(html => {
                var parser = new DOMParser();
                var doc = parser.parseFromString(html, 'text/html');
                if (doc.querySelector('#thb-secondary-area--item-text') != null) {
                 var mainSectionContent = doc.querySelector('#thb-secondary-area--item-text').innerHTML;
                 document.querySelector('#thb-secondary-area--item-text').innerHTML = mainSectionContent; 
                }
              })
              .catch(error => {
                console.error('Error fetching collection main section:', error);
              });
        }, 500);
        
    }
    refresh() {
      let sections = 'cart-drawer,cart-bubble';
      fetch(`${window.location.pathname}?sections=${sections}`)
        .then((response) => {
          return response.text();
        })
        .then((state) => {
          const parsedState = JSON.parse(state);

          this.getSectionsToRender().forEach((section => {
            const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

            elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState[section.section], section.selector);
          }));

          this.removeProductEvent();
          
        });
    }
  }
  customElements.define('cart-drawer', CartDrawer);
}

/**
 *  @class
 *  @function LocalizationForm
 */
if (!customElements.get('localization-form')) {
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.inputs = this.form.querySelectorAll('[name="locale_code"], [name="country_code"]');
      this.debouncedOnSubmit = debounce((event) => {
        this.onSubmitHandler(event);
      }, 200);
      this.inputs.forEach(item => item.addEventListener('change', this.debouncedOnSubmit.bind(this)));
    }
    onSubmitHandler(event) {
      if (this.form) this.form.submit();
    }
  }
  customElements.define('localization-form', LocalizationForm);
}

/**
 *  @class
 *  @function ResizeSelect
 */
if (!customElements.get('resize-select')) {
  class ResizeSelect extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.select = this.querySelector('select');
      this.addEventListeners();
    }
    addEventListeners() {
      this.addEventListener('change', this.resizeSelect.bind(this));
      window.addEventListener('load', this.resizeSelect.bind(this));
      this.resizeSelect();
    }
    resizeSelect() {
      let tempOption = document.createElement('option');
      tempOption.textContent = this.select.selectedOptions[0].textContent;

      let tempSelect = document.createElement('select'),
        offset = 10;
      tempSelect.style.visibility = 'hidden';
      tempSelect.style.position = 'fixed';
      tempSelect.appendChild(tempOption);
      this.after(tempSelect);
      if (tempSelect.clientWidth > 0) {
        this.select.style.width = `${+tempSelect.clientWidth + offset}px`;
      }
      tempSelect.remove();
    }
  }
  customElements.define('resize-select', ResizeSelect);
}

/**
 *  @class
 *  @function QuickView
 */
if (!customElements.get('quick-view')) {
  class QuickView extends HTMLElement {
    constructor() {
      super();
      this.cache = new Map();
      this.abortController = null;
    }

    connectedCallback() {
      if (this._connected) return;
      this._connected = true;
      this.drawer = document.getElementById('Product-Modal');
      this.body = document.body;

      this._setupEventListener = this.setupEventListener.bind(this);
      this.addEventListener('click', this._setupEventListener);
      this.addEventListener('keypress', this._setupEventListener);
    }

    setupEventListener(e) {
      if (e.key && e.key !== 'Enter') return;

      e.preventDefault();

      const productHandle = this.dataset.productHandle;
      let href = `${theme.routes.root_url}/products/${productHandle}?view=quick-view`;

      href = href.replace('//', '/');

      if (!href || !productHandle) return;
      if (this.classList.contains('loading')) return;

      if (this.abortController) {
        this.abortController.abort();
      }
      this.abortController = new AbortController();

      this.classList.add('loading');

      if (this.cache.has(productHandle)) {
        this.classList.remove('loading');
        this.renderQuickview(this.cache.get(productHandle), href, productHandle);
        return;
      }

      fetch(href, { 
        method: 'GET',
        signal: this.abortController.signal,
        headers: {
          'Cache-Control': 'max-age=300'
        }
      })
        .then(response => {
          if (!response.ok) throw new Error('Network response was not ok');
          return response.text();
        })
        .then(text => {
          this.classList.remove('loading');
          
          const sectionInnerHTML = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('#Product-Modal-Content')?.innerHTML;

          if (!sectionInnerHTML) {
            throw new Error('Could not find product content');
          }

          this.cache.set(productHandle, sectionInnerHTML);
          
          this.renderQuickview(sectionInnerHTML, href, productHandle);
        })
        .catch(error => {
          this.classList.remove('loading');
          if (error.name !== 'AbortError') {
            console.error('QuickView fetch error:', error);
          }
        });
    }

    showModalWithLoader() {

      this.drawer.querySelector('#Product-Modal-Content').innerHTML = `
        <div class="quick-view-loader" style="
          display: flex; 
          align-items: center; 
          justify-content: center; 
          min-height: 300px;
          flex-direction: column;
          gap: 16px;
        ">
          <div style="
            width: 40px; 
            height: 40px; 
            border: 3px solid #f3f3f3; 
            border-top: 3px solid #333; 
            border-radius: 50%; 
            animation: spin 1s linear infinite;
          "></div>
          <p>Loading product...</p>
          <style>
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
          </style>
        </div>
      `;
      
      this.drawer.setAttribute('open', '');
      document.body.classList.add('open-drawer');
      this.drawer.querySelector('.product-modal__toggle')?.focus();
    }

    hideModal() {
      this.drawer.removeAttribute('open');
      document.body.classList.remove('open-drawer');
    }

    renderQuickview(sectionInnerHTML, href, productHandle) {
      if (!sectionInnerHTML) return;

      requestAnimationFrame(() => {
        this.drawer.querySelector('#Product-Modal-Content').innerHTML = sectionInnerHTML;

        this.loadScriptsAsync();

        this.initializeComponents();

        this.drawer.setAttribute('open', '');
        document.body.classList.add('open-drawer');
        const toggle = this.drawer.querySelector('.product-modal__toggle');
        if (toggle) toggle.focus();

        this.dispatchEvents(href, productHandle);
      });
    }

    loadScriptsAsync() {
      const jsFiles = this.drawer.querySelectorAll('#Product-Modal-Content script');
      if (jsFiles.length === 0) return;

      const head = document.head;
      const loadPromises = [];

      jsFiles.forEach(jsFile => {
        if (!jsFile.src) return;
        
        if (document.querySelector(`script[src="${jsFile.src}"]`)) return;

        const promise = new Promise((resolve, reject) => {
          const script = document.createElement('script');
          script.src = jsFile.src;
          script.async = true;
          script.onload = resolve;
          script.onerror = reject;
          head.appendChild(script);
        });
        
        loadPromises.push(promise);
      });

      Promise.allSettled(loadPromises).then(() => {
      });
    }

    initializeComponents() {
      const initFunc = () => {
        const swiperElement = this.drawer.querySelector('.quick-mobile.swiper');
        if (swiperElement && window.Swiper) {
          new Swiper(swiperElement, {
            slidesPerView: 1.8,
            spaceBetween: 5,
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            },
            freeMode: true,
            loop: false,
            lazy: true,
            preloadImages: false,
          });
        }

        if (window.Shopify?.PaymentButton) {
          window.Shopify.PaymentButton.init();
        }
        if (window.ProductModel) {
          window.ProductModel.loadShopifyXR();
        }

        setTimeout(() => {
          const slider = this.drawer.querySelector('#Product-Slider');
          if (slider?.reInit) {
            slider.reInit();
          }
          window.dispatchEvent(new Event('resize'));
        }, 50);
      };

      if (window.requestIdleCallback) {
        window.requestIdleCallback(initFunc, { timeout: 200 });
      } else {
        setTimeout(initFunc, 50);
      }
    }

    dispatchEvents(href, productHandle) {

      if (window.dispatchCustomEvent) {
        window.dispatchCustomEvent('quick-view:open', {
          productUrl: href,
          productHandle,
        });
      }

      if (window.addIdToRecentlyViewed) {
        window.addIdToRecentlyViewed(productHandle);
      }
    }

    disconnectedCallback() {
      if (this.abortController) {
        this.abortController.abort();
      }
      
      if (this.cache.size > 10) {
        this.cache.clear();
      }
    }
  }

  customElements.define('quick-view', QuickView);
}


/**
 *  @class
 *  @function ThemeScroll
 */
if (!customElements.get('theme-scroll')) {
  class ThemeScroll extends HTMLElement {
    constructor() {
      super();

      this.viewport = this.querySelector('.theme-scroll--inner');
      this.slideWidth = 274;
      this.slidesToScroll = 1;
    }
    connectedCallback() {
      window.OverlayScrollbarsGlobal.OverlayScrollbars({
        target: this,
        elements: {
          viewport: this.viewport,
        }
      }, {});

      this.init();
    }
    init() {
      // alert("clal");
      this.setSlides();
      this.reachedEnd = 0;

      if (this.slides.length < 1) {
        return;
      }
      this.nav = this.querySelector('.theme-scroll-nav');
      this.navPrev = this.querySelector('.flickity-prev');
      this.navNext = this.querySelector('.flickity-next');
      this.resizeObserver = new ResizeObserver((entries) => {
        this.slideWidth = this.slides[1].offsetLeft - this.slides[0].offsetLeft;
        this.reachedEnd = this.viewport.scrollWidth - this.viewport.offsetWidth == this.viewport.scrollLeft;
        this.onNavDisabled();
      }, {
        root: this
      });
      this.debouncedOnScroll = debounce((event) => {
        this.onScroll(event);
      }, 100);

      this.setListeners();
      this.centerArrows();
    }
    setSlides() {
      this.slides = this.querySelectorAll('.carousel__slide');
      this.slidesLength = this.slides.length;
      this.lastSlide = this.slides[this.slides.length - 1];
    }
    setListeners() {
      this.nav.addEventListener('click', this.onNavClick.bind(this));
      this.viewport.addEventListener('scroll', this.debouncedOnScroll.bind(this));
      this.viewport.addEventListener('resize', this.debouncedOnScroll.bind(this));
      this.resizeObserver.observe(this.slides[0]);
    }
    onScroll() {
      this.reachedEnd = this.viewport.scrollWidth - this.viewport.offsetWidth == Math.floor(this.viewport.scrollLeft);
      this.onNavDisabled();
    }
    onNavClick(e) {
      if (!e.target.matches('.flickity-nav')) {
        return;
      }
      if (e.target.name === 'next') {
        this.scrollPos = this.viewport.scrollLeft + this.slidesToScroll * this.slideWidth;
      } else if (e.target.name === 'prev') {
        this.scrollPos = this.viewport.scrollLeft - this.slidesToScroll * this.slideWidth;
      }
      this.viewport.scrollTo({
        left: this.scrollPos,
        behavior: "smooth"
      });
    }
    onNavDisabled() {
      if (this.navPrev) {
        this.navPrev.disabled = this.viewport.scrollLeft === 0 ? 1 : 0;
      }
      if (this.navNext) {
        this.navNext.disabled = this.reachedEnd ? 1 : 0;
      }
    }
    centerArrows() {
      let first_cell = this.slides[0],
        max_height = 0,
        image_height = 0;
      if (first_cell.querySelector('.product-card-image')) {
        image_height = first_cell.querySelector('.product-card-image').clientHeight;
      } else if (first_cell.querySelector('.gallery--item')) {
        image_height = this.slides[1].querySelector('.product-card-image').clientHeight;
      }
      if (image_height > 0) {
        this.slides.forEach((item, i) => {
          if (item.clientHeight > max_height) {
            max_height = item.clientHeight;
          }
        });

        if (max_height > image_height) {
          let difference = (max_height - image_height) / -2;

          this.navPrev.style.transform = 'translateY(' + difference + 'px)';
          this.navNext.style.transform = 'translateY(' + difference + 'px)';
        }
      }
    }
  }
  customElements.define('theme-scroll', ThemeScroll);
}

/**
 *  @class
 *  @function CollapsibleRow
 */
if (!customElements.get('collapsible-row')) {
  // https://css-tricks.com/how-to-animate-the-details-element/
  class CollapsibleRow extends HTMLElement {
    constructor() {
      super();

      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.content = this.querySelector('.collapsible__content');
      this.collapsed_mobile = this.classList.contains('accordion--collapsed-mobile');

      // Store the animation object (so we can cancel it if needed)
      this.animation = null;
      // Store if the element is closing
      this.isClosing = false;
      // Store if the element is expanding
      this.isExpanding = false;
    }
    connectedCallback() {
      this.setListeners();
    }
    setListeners() {
      if (this.initialized) { return; }
      this.querySelector('summary').addEventListener('click', (e) => this.onClick(e));

      this.initialized = true;
      if (this.collapsed_mobile) {
        window.addEventListener('resize', () => {
          this.details.open = window.innerWidth > 768;
        });
        window.dispatchEvent(new Event('resize'));
      }
    }
    onClick(e) {
      // Stop default behaviour from the browser
      e.preventDefault();
      // Add an overflow on the <details> to avoid content overflowing
      this.details.style.overflow = 'hidden';

      // Close other open details elements
      document.querySelectorAll('collapsible-row details[open]').forEach((detail) => {
        if (detail !== this.details) {
          detail.removeAttribute('open');
        }
      });

      // Check if the element is being closed or is already closed
      if (this.isClosing || !this.details.open) {
        this.open();
        // Check if the element is being openned or is already open
      } else if (this.isExpanding || this.details.open) {
        this.shrink();
      }
    }
    shrink() {
      // Set the element as "being closed"
      this.isClosing = true;

      // Store the current height of the element
      const startHeight = `${this.details.offsetHeight}px`;
      // Calculate the height of the summary
      const endHeight = `${this.summary.offsetHeight}px`;

      // If there is already an animation running
      if (this.animation) {
        // Cancel the current animation
        this.animation.cancel();
      }

      // Start a WAAPI animation
      this.animation = this.details.animate({
        // Set the keyframes from the startHeight to endHeight
        height: [startHeight, endHeight]
      }, {
        duration: 250,
        easing: 'ease'
      });

      // When the animation is complete, call onAnimationFinish()
      this.animation.onfinish = () => this.onAnimationFinish(false);
      // If the animation is cancelled, isClosing variable is set to false
      this.animation.oncancel = () => this.isClosing = false;
    }

    open() {
      // Apply a fixed height on the element
      this.details.style.height = `${this.details.offsetHeight}px`;
      // Force the [open] attribute on the details element
      this.details.open = true;
      // Wait for the next frame to call the expand function
      window.requestAnimationFrame(() => this.expand());
    }

    expand() {
      // Set the element as "being expanding"
      this.isExpanding = true;
      // Get the current fixed height of the element
      const startHeight = `${this.details.offsetHeight}px`;
      // Calculate the open height of the element (summary height + content height)
      const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;

      // If there is already an animation running
      if (this.animation) {
        // Cancel the current animation
        this.animation.cancel();
      }

      // Start a WAAPI animation
      this.animation = this.details.animate({
        // Set the keyframes from the startHeight to endHeight
        height: [startHeight, endHeight]
      }, {
        duration: 250,
        easing: 'ease-out'
      });
      // When the animation is complete, call onAnimationFinish()
      this.animation.onfinish = () => this.onAnimationFinish(true);
      // If the animation is cancelled, isExpanding variable is set to false
      this.animation.oncancel = () => this.isExpanding = false;
    }

    onAnimationFinish(open) {
      // Set the open attribute based on the parameter
      this.details.open = open;
      // Clear the stored animation
      this.animation = null;
      // Reset isClosing & isExpanding
      this.isClosing = false;
      this.isExpanding = false;
      // Remove the overflow hidden and the fixed height
      this.details.style.height = this.details.style.overflow = '';

      this.dispatchEvent(new Event('animationend', { bubbles: false }));
    }
  }
  customElements.define('collapsible-row', CollapsibleRow);
}

/**
 *  @function addIdToRecentlyViewed
 */
function addIdToRecentlyViewed(handle) {
  if (!handle) {
    let product = document.querySelector('.thb-product-detail');

    if (product) {
      handle = product.dataset.handle;

    }
  }
  if (!handle) {
    return;
  }
  if (window.localStorage) {
    let recentIds = window.localStorage.getItem('recently-viewed');
    if (recentIds && typeof (recentIds) !== undefined) {
      window.recentlyViewedIds = JSON.parse(recentIds);
    }
  }
  var i = window.recentlyViewedIds.indexOf(handle);

  if (i > -1) {
    window.recentlyViewedIds.splice(i, 1);
  }
  window.recentlyViewedIds.unshift(handle);

  if (window.localStorage) {
    window.localStorage.setItem('recently-viewed', JSON.stringify(window.recentlyViewedIds));
  }
}

document.addEventListener('DOMContentLoaded', () => {
  let scrollbarWidth = window.innerWidth - document.body.clientWidth;
  document.documentElement.style.setProperty('--scrollbar-width', scrollbarWidth + 'px');
});

document.addEventListener("DOMContentLoaded", function () {
  const overlay = document.querySelector('.overlay-new');
  if (overlay) {
    overlay.addEventListener('click', function () {
      document.body.classList.remove('overflow-hidden');
      const mobileToggleWrapper = document.querySelector('.mobile-toggle-wrapper');
      if (mobileToggleWrapper) {
        mobileToggleWrapper.classList.remove('active');
        mobileToggleWrapper.removeAttribute('open');
      }
    });
  } else {
    console.warn("Element .overlay-new not found.");
  }
});


// document.addEventListener('DOMContentLoaded', function() {
//   var continueShoppingButton = document.getElementById('continue-shopping-button');
//   var cartDrawerToggle = document.getElementById('cart-drawer-toggle');

//   if (continueShoppingButton && cartDrawerToggle) {
//       continueShoppingButton.addEventListener('click', function(event) {
//           alert('click')
//           event.preventDefault();
          
//           cartDrawerToggle.click();
//       });
//   }
// });

document.addEventListener('DOMContentLoaded', function () {
  document.body.addEventListener('click', function (event) {
      if (event.target && event.target.id === 'continue-shopping-button') {
          event.preventDefault();
          var cartDrawerToggle = document.getElementById('cart-drawer-toggle');

          if (cartDrawerToggle) {
              cartDrawerToggle.click();
          }
      }
  });
});



document.addEventListener("DOMContentLoaded", function () {
  initProductCardSizeSelectors();
  initSizeOpenButtons();
});

function initProductCardSizeSelectors(container = document) {
  const sizeSelectors = container.querySelectorAll(
    ".product-card-info--bottom .size-selector"
  );

  sizeSelectors.forEach((selector) => {
    if (selector.dataset.initialized) return;
    selector.dataset.initialized = true;

    selector.addEventListener("click", function (e) {
      e.preventDefault();

      const variantId = selector.getAttribute("data-id");
      if (!variantId) {
        console.error("Variant ID missing");
        return;
      }

      const formData = new FormData();
      formData.append("id", variantId);
      formData.append("quantity", 1);
      formData.append(
        "sections",
        getSectionsToRender().map((section) => section.section)
      );
      formData.append("sections_url", window.location.pathname);

      fetch("/cart/add.js", {
        method: "POST",
        body: formData,
        cache: "no-cache",
      })
        .then((response) => {
          if (!response.ok) throw new Error("Failed to add to cart");
          return response.json();
        })
        .then((data) => {
          console.log("Added to cart:", data);
          cartDrawerUpdateNew();
          if (data.sections) updateCartSections(data);
          setTimeout(cartOpen, 200);
          productRecommended();
        })
        .catch((error) => console.error("Add to cart error:", error));
    });
  });
}

 function cartDrawerUpdateNew() {
  console.log("Calling cartDrawerUpdateNew");
  var url = window.location.href;
  fetch(url)
   .then(response => response.text())
   .then(html => {
    var parser = new DOMParser();
    var doc = parser.parseFromString(html, 'text/html');
    if (doc.querySelector('#thb-secondary-area--item-text') != null) {
     var mainSectionContent = doc.querySelector('#thb-secondary-area--item-text').innerHTML;
     document.querySelector('#thb-secondary-area--item-text').innerHTML = mainSectionContent;
    }
    if (doc.querySelector('.thb-cart-form--proceed') != null) {
     var mainSectionContent = doc.querySelector('.thb-cart-form--proceed').innerHTML;
     document.querySelector('.thb-cart-form--proceed').innerHTML = mainSectionContent;
    }
   })
   .catch(error => {
    console.error('Error fetching collection main section:', error);
   });
 }

function initSizeOpenButtons(container = document) {
  const sizeButtons = container.querySelectorAll(
    ".product-card-info--bottom .size-open-btn"
  );

  sizeButtons.forEach((btn) => {
    if (btn.dataset.initialized) return;
    btn.dataset.initialized = true;

    btn.addEventListener("click", function () {
      const parentBottom = btn.closest(".product-card-info--bottom");
      if (!parentBottom) return;

      container
        .querySelectorAll(".product-card-info--bottom.active")
        .forEach((el) => el.classList.remove("active"));

      parentBottom.classList.add("active");
    });
  });
}


function getSectionsToRender() {
  return [
    { id: "Cart", section: "main-cart", selector: ".thb-cart-form--form" },
    { id: "Cart-Drawer", section: "cart-drawer", selector: ".cart-drawer" },
    { id: "Cart-Badge", section: "cart-bubble", selector: "#thb-secondary-area--item-text" },
  ];
}

function updateCartSections(data) {
  getSectionsToRender().forEach((section) => {
    const html = new DOMParser().parseFromString(
      data.sections[section.section],
      "text/html"
    );
    const updatedContent = html.querySelector(section.selector);
    const container = document.querySelector(section.selector);

    if (updatedContent && container) {
      container.innerHTML = updatedContent.innerHTML;
    }
  });
}




function cartOpen() {
  const cartDrawer = document.querySelector(".cart-drawer");
  if (!cartDrawer) return;

  cartDrawer.removeAttribute("inert");
  cartDrawer.focus();
  cartDrawer.isOpen = true;
  document.dispatchEvent(new CustomEvent("cart-drawer:open"));
  document.body.classList.add("open-cart");

  const removes = cartDrawer.querySelectorAll(".remove");
  removes.forEach((remove) => {
    remove.addEventListener("click", (event) => {
      if (typeof cartDrawer.updateQuantity === "function") {
        cartDrawer.updateQuantity(event.target.dataset.index, "0");
      }
      event.preventDefault();
    });
  });
}



document.addEventListener('click', function (event) {
  const quickViewBtn = event.target.closest('quick-view.one-size');
  if (!quickViewBtn) return;

  event.preventDefault();
  event.stopPropagation();

  const variantId = quickViewBtn.dataset.productId;
  if (!variantId) return;

  quickViewBtn.classList.add('loading');

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  })
    .then((response) => {
      if (!response.ok) throw new Error('Failed to add to cart');
      return response.json();
    })
    .then((data) => {
      console.log('Added to cart:', data);

      // Fetch updated cart drawer HTML (without full reload)
      return fetch(window.location.pathname + '?sections=cart-drawer');
    })
    .then((res) => res.json())
    .then((sectionData) => {
      const parser = new DOMParser();
      const newHTML = parser.parseFromString(sectionData['cart-drawer'], 'text/html');
      const newDrawer = newHTML.querySelector('.cart-drawer');

      const oldDrawer = document.querySelector('.cart-drawer');
      if (oldDrawer && newDrawer) {
        oldDrawer.innerHTML = newDrawer.innerHTML;
      }

      // Optional: Open drawer and trigger other logic
      cartDrawerUpdateNew?.();
      setTimeout(cartOpen, 100);
      productRecommended?.();
    })
    .catch((error) => {
      console.error('Error adding one-size product to cart:', error);
    })
    .finally(() => {
      quickViewBtn.classList.remove('loading');
    });
});


async function productRecommended() {
  const firstItem = document.querySelector('cart-drawer .product-cart-item');

  if (!firstItem) return;

  const productId = firstItem.getAttribute('data-product-id');
  const container = document.getElementById('complementary-products-container');
  if (!container) return;

  const wrapper = container.querySelector('.swiper-wrapper');
  if (!wrapper) return;

  const SECTION_ID = 'product-recommended-grid';

  try {
    const response = await fetch(`/recommendations/products.json?product_id=${productId}&limit=6`);

    if (!response.ok) throw new Error(`HTTP ${response.status}`);

    const data = await response.json();
    const handles = (data.products || []).map(p => p.handle).filter(Boolean);

    if (handles.length === 0) {
      wrapper.innerHTML = '<li class="swiper-slide">No recommendations found.</li>';
      return;
    }

    const sections = await Promise.all(
      handles.map(async handle => {
        try {
          const res = await fetch(`/products/${handle}?sections=${SECTION_ID}`);
          const json = await res.json();
          return json[SECTION_ID];
        } catch (err) {
          console.error(`Failed to load ${handle}:`, err);
          return `<div class="error">Failed to load ${handle}</div>`;
        }
      })
    );

    wrapper.innerHTML = sections
      .map(sectionHTML => `<li class="swiper-slide">${sectionHTML}</li>`)
      .join('');

    if (window.cartRecommendedSwiper) {
      window.cartRecommendedSwiper.destroy(true, true);
      window.cartRecommendedSwiper = null;
    }

    if (window.Swiper) {
      window.cartRecommendedSwiper = new Swiper('.cart-recommended-slider', {
        slidesPerView: 'auto',
        spaceBetween: 16,
        slidesOffsetBefore: 20,
        slidesOffsetAfter: 20,
        scrollbar: { el: '.swiper-scrollbar' },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      });
    }



  } catch (error) {
    console.error('Error fetching recommendations:', error);
    wrapper.innerHTML = '<li class="swiper-slide error">Error loading recommended products.</li>';
  }
}

productRecommended();